import styled from "styled-components";

import { ButtonLink } from "@anwb/typography";

export const ProgressIndicator = styled(ButtonLink)`
  border: none;
  white-space: nowrap;
`;
